import {useMarkdownConverter} from '#imports';

export function useMarkdownToHtml() {
    const {mdToHtml} = useMarkdownConverter();

    function markdownToHtml(markdown?: string, override?: {h1: string}): string {
        if (typeof markdown !== 'string') return '';
        const escaped = markdown.replace(/</gi, '&lt;').replace(/>/gi, '&gt;');
        return mdToHtml(escaped, override);
    }

    return {
        markdownToHtml,
    };
}
